import { css } from 'lit';

export const styles = css`
  :host {
    box-sizing: border-box;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none;
  }

  :host {
    display: block;
    width: 100%;
  }

  .detail {
    border: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-secondary));
    border-radius: var(--nile-radius-md, var(--ng-radius-xl));
    background-color: var(--nile-colors-white-base, var(--ng-colors-bg-primary));
    box-shadow: var(--nile-box-shadow-3, var(--ng-shadow-xs));
    overflow: hidden;
    width: 100%;
    line-height: var(--nile-line-height-inherit, var(--ng-line-height-text-sm));
    font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
  }

  .detail--disabled {
    opacity: var(--nile-opacity-50, var(--ng-opacity-50));
  }

  .detail__header {
    display: flex;
    gap: var(--nile-spacing-lg, var(--ng-spacing-lg));
    align-items: center;
    border-radius: inherit;
    padding: var(--nile-spacing-xl, var(--ng-spacing-xl));
    background-color: var(--nile-colors-neutral-100, var(--ng-colors-bg-tertiary));
    font-size: var(--nile-type-scale-4, var(--ng-spacing-xl));
    font-weight: var(--nile-font-weight-semibold, var(--ng-font-weight-semibold));
    color: var(--nile-colors-neutral-900, var(--ng-colors-text-primary));
    user-select: none;
    cursor: pointer;
    list-style: none;
  }

  .detail__header::-webkit-details-marker {
    display: none;
  }

  .detail__header::marker {
    content: '';
  }

  .detail__header--icon-left {
    flex-direction: row-reverse;
  }

  .detail__header:focus {
    outline: none;
  }

  .detail__header:focus-visible {
    outline: solid 3px var(--nile-colors-blue-500, var(--ng-colors-fg-brand-primary-600));
    outline-offset: calc(1px + 1px);
  }

  .detail--disabled .detail__header {
    cursor: not-allowed;
  }

  .detail--disabled .detail__header:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .detail__label {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .detail__header-actions {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: var(--nile-spacing-sm, var(--ng-spacing-sm));
  }

  .detail__prefix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: var(--nile-spacing-sm, var(--ng-spacing-sm));
  }

  .detail__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: var(--nile-spacing-sm, var(--ng-spacing-sm));
  }

  .detail__heading-text {
    font-weight: var(--nile-font-weight-semibold, var(--ng-font-weight-semibold));
    font-family: var(--nile-font-family-medium, var(--ng-font-family-body));
    font-size: var(--nile-type-scale-4, var(--ng-spacing-xl));
  }

  .detail__description {
    font-size: var(--nile-type-scale-2, var(--ng-font-size-text-xs));
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    color: var(--nile-colors-dark-500, var(--ng-colors-text-secondary));
    margin-top: 2px;
  }

  .detail__summary-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: 250ms transform ease;
    color: var(--nile-colors-neutral-700, var(--ng-colors-text-secondary));
    transform: rotate(90deg);
  }

  .detail--open .detail__summary-icon {
    transform: rotate(-90deg);
  }

  .detail__body {
    overflow: hidden;
  }

  .detail__body[hidden] {
    display: none;
  }

  .detail__content {
    display: block;
    padding: var(--nile-spacing-xl, var(--ng-spacing-xl));
  }
`;

export default [styles];
